import { useEventFormFunctionalWrapperGuestAnswersQuery } from '@graphql/generated';
import { answersToFormState } from '../answersToFormState';
import { useActiveSession } from './useActiveSession';
import { EventFormContactData } from '../../../presentational/hooks/useEventFormState';

const useGuestAnswers = (formId: string, eventId: string) => {
  const { data: answersData, loading: answersLoading } = useEventFormFunctionalWrapperGuestAnswersQuery({
    variables: {
      formId,
      eventId,
    },
    batchMode: 'fast',
    skip: !eventId,
  });

  const fromAnswers = answersData?.guestAnswersByFormId ?? [];

  const { formValues } = answersToFormState(fromAnswers);

  const contactRaw = fromAnswers[0]?.contact;
  let contact: EventFormContactData | undefined = undefined;

  if (contactRaw?.firstName && contactRaw?.lastName && contactRaw?.email) {
    contact = {
      firstName: contactRaw.firstName,
      lastName: contactRaw.lastName,
      email: contactRaw.email,
    };
  }

  return { answers: formValues, loading: answersLoading, contact };
};

export const useAnswerByGuestSession = (formId: string, eventId: string) => {
  const { guestKey, loading: sessionLoading } = useActiveSession(eventId);
  const { answers, loading: answersLoading, contact } = useGuestAnswers(formId, eventId);

  const loading = sessionLoading || answersLoading;

  return { loading, answers, guestKey, contact };
};
